import { FeatureCategory } from '../types';

export const progressFeatures: FeatureCategory = {
  name: "Progress Check-ins",
  icon: "TrendingUp",
  features: [
    { 
      name: "ThriveScore Tracking", 
      description: "Daily wellness score based on activity, social connection, health metrics, and safety assessments. Track trends over time to optimize your well-being.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "My Daily Check-In", 
      description: "Quick daily wellness check-in to track how you're feeling, rate your energy, and log important daily activities.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    }
  ]
};
